// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__1pRWD","label":"styles_label__338h-","input":"styles_input__1qMz5"};